import { is, pathOr } from 'ramda'

const isArray = is(Array)

/**
 * Finds a given function from the pool config serviceArgs.
 *
 * @param {HttpCachePoolConfig} poolConfig
 * @param {Array<string>|string} valuePath
 * @param {*} defaultValue
 * @return {function(string, Array)}
 */
const getServiceArgsValue = (poolConfig, valuePath, defaultValue = undefined) => pathOr(
  defaultValue,
  isArray(valuePath) ? valuePath : [valuePath],
  poolConfig.serviceArgs,
)

export default getServiceArgsValue
